var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"recurring-job-listing white-background main-listing-page pb-0",attrs:{"fluid":""}},[_c('div',[_c('RecurringListingTemplate',{attrs:{"is-hideColumn":_vm.isHideColumn,"visitType":"all","detail-route":`${
        _vm.follow_up_route == 1 ? 'follow-up.detail' : 'recurring-job.detail'
      }`}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }